import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import TagsLoop from '../components/TagsLoop'

const Tags = ({ pageContext, data }) => {
	const { tag } = pageContext
	const { totalCount } = data.allMarkdownRemark
	const firstThumbnail =
		data.allMarkdownRemark.edges[0].node.frontmatter.thumbnail

	return (
		<Layout>
			<div className="cover-outer">
				<div
					className={`cover-wrap visible animate fade-in ${firstThumbnail &&
						`has-bg`}`}
					style={
						firstThumbnail && {
							backgroundImage: `url(${firstThumbnail.childImageSharp.fluid.src})`,
						}
					}
				>
					<div className="cover-tag text-center">
						<div className="cover-inner">
							<h1 className="name h3">{tag}</h1>
							<div className="post-count">
								Total {totalCount === 1 ? `1 Post` : `${totalCount} Posts`}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="post-list-theme-1 post-list-wrap">
				<TagsLoop data={data} />
			</div>
		</Layout>
	)
}

export default Tags

export const pageQuery = graphql`
	query($tag: String) {
		avatar: file(absolutePath: { regex: "/profile-pic./" }) {
			childImageSharp {
				fixed(width: 40, height: 40) {
					...GatsbyImageSharpFixed
				}
			}
		}
		allMarkdownRemark(
			limit: 2000
			sort: { fields: [frontmatter___date], order: DESC }
			filter: { frontmatter: { tags: { in: [$tag] } } }
		) {
			totalCount
			edges {
				node {
					fields {
						slug
					}
					timeToRead
					frontmatter {
						date(formatString: "MMMM DD, YYYY")
						title
						tags
						description
						featured
						thumbnail {
							childImageSharp {
								fluid(maxWidth: 1080) {
									...GatsbyImageSharpFluid
								}
							}
						}
					}
				}
			}
		}
	}
`
